"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const pascalCase$1 = require("pascal-case");
const pascalCase = (...input) => {
  return pascalCase$1.pascalCase(input.filter(Boolean).join(" "), {
    transform: pascalCase$1.pascalCaseTransformMerge
  });
};
exports.pascalCase = pascalCase;
//# sourceMappingURL=pascalCase.cjs.map
